/* Progressive enhancement: readable without animation or JavaScript. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const motionOff = () => reduced.matches || document.body.classList.contains('p26-motion-paused');
  const carousels = [];
  document.querySelectorAll('[data-cr-carousel]').forEach(root => {
    const logos = root.dataset.crCarousel === 'logos';
    const track = root.querySelector(logos ? '.cr-community-track' : '.cr-review-track');
    const button = root.querySelector('[data-cr-pause]');
    if (!track || !button) return;
    let paused = false, hovering = false, focused = false, visible = false, lastStep = performance.now(), lastFrame = 0, loopWidth = 0;
    const items = logos ? [...track.firstElementChild.children] : [...track.children];
    if (logos) {
      const clone = track.firstElementChild.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true'); clone.setAttribute('inert', '');
      clone.querySelectorAll('[id]').forEach(e => e.removeAttribute('id'));
      track.append(clone);
      const measure = () => { loopWidth = clone.offsetLeft - track.firstElementChild.offsetLeft; };
      new ResizeObserver(measure).observe(track); measure();
    }
    const isStopped = () => paused || hovering || focused || motionOff() || document.hidden || !visible;
    const sync = () => {
      const stopped = paused || motionOff();
      button.textContent = `${stopped ? 'Play' : 'Pause'} ${logos ? 'client logos' : 'reviews'}`;
      button.setAttribute('aria-pressed', String(stopped));
      button.disabled = motionOff();
      button.title = motionOff() ? 'Motion is paused. Use the arrows or scroll to browse.' : '';
      root.dataset.crPaused = String(stopped);
    };
    const step = direction => {
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const width = items[0].getBoundingClientRect().width + gap;
      let target = track.scrollLeft + width * direction;
      const end = logos ? loopWidth : track.scrollWidth - track.clientWidth;
      if (target > end + 4) target = 0;
      if (target < 0) target = end;
      track.scrollTo({left:target, behavior:motionOff()?'instant':'smooth'});
      lastStep = performance.now();
    };
    button.addEventListener('click', () => {paused = !paused; sync(); lastStep = performance.now();});
    root.querySelector('[data-cr-prev]').addEventListener('click', () => step(-1));
    root.querySelector('[data-cr-next]').addEventListener('click', () => step(1));
    root.addEventListener('mouseenter', () => hovering=true);
    root.addEventListener('mouseleave', () => {hovering=false;lastStep=performance.now();});
    root.addEventListener('focusin', () => focused=true);
    root.addEventListener('focusout', () => {focused=root.contains(document.activeElement);lastStep=performance.now();});
    track.addEventListener('pointerdown', () => {paused=true;sync();});
    track.addEventListener('keydown', e => {if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();step(e.key==='ArrowRight'?1:-1);}});
    track.addEventListener('scroll', () => {
      if (!logos) {
        const width = items[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||0);
        root.querySelector('[data-cr-position]').textContent=`Review ${Math.min(items.length,Math.round(track.scrollLeft/width)+1)} of ${items.length}`;
      }
    }, {passive:true});
    new IntersectionObserver(entries => {visible=entries[0].isIntersecting;lastFrame=0;lastStep=performance.now();},{threshold:.1}).observe(root);
    carousels.push({sync,tick(now){
      if(isStopped()){lastFrame=0;lastStep=now;return;}
      if(logos && loopWidth>0){const elapsed=lastFrame?Math.min(now-lastFrame,50):0;track.scrollLeft += elapsed*.028;if(track.scrollLeft>=loopWidth)track.scrollLeft-=loopWidth;lastFrame=now;}
      else if(!logos && now-lastStep>8000){step(1);}
    }});
    sync();
  });
  // One lightweight frame loop, active only for carousels currently in view.
  const tick = now => {carousels.forEach(c=>c.tick(now));requestAnimationFrame(tick);};
  if(carousels.length) requestAnimationFrame(tick);
  const syncMotion = () => carousels.forEach(c=>c.sync());
  new MutationObserver(syncMotion).observe(document.body,{attributes:true,attributeFilter:['class']});
  reduced.addEventListener('change',syncMotion);
  document.querySelectorAll('[data-cr-depth]').forEach(card => {
    let frame=0, x=0, y=0;
    card.addEventListener('pointermove',e=>{
      if(motionOff()||!fine.matches)return;
      const r=card.getBoundingClientRect();x=(e.clientX-r.left)/r.width-.5;y=(e.clientY-r.top)/r.height-.5;
      if(!frame)frame=requestAnimationFrame(()=>{card.style.setProperty('--cr-rx',(-y*4).toFixed(2)+'deg');card.style.setProperty('--cr-ry',(x*4).toFixed(2)+'deg');frame=0;});
    });
    card.addEventListener('pointerleave',()=>{card.style.removeProperty('--cr-rx');card.style.removeProperty('--cr-ry');});
  });
  if('IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(!e.isIntersecting)return;observer.unobserve(e.target);if(!motionOff())e.target.classList.add('cr-immersive-reveal');}),{threshold:.12});
    document.querySelectorAll('#why-caqa article,#compliance-resources .r3-compliance-grid>a,.cr-support-card,.cr-stat-card,#questions-answers details').forEach(e=>observer.observe(e));
    const stats=new IntersectionObserver(entries=>entries.forEach(e=>{
      if(!e.isIntersecting)return;stats.unobserve(e.target);
      if(motionOff())return;
      const final=e.target.textContent, match=final.match(/^(\d+)(.*)$/);if(!match)return;
      const target=Number(match[1]),start=performance.now();e.target.setAttribute('aria-label',final);
      const count=now=>{if(motionOff()){e.target.textContent=final;return;}const p=Math.min((now-start)/900,1);e.target.textContent=Math.round(target*(1-Math.pow(1-p,3)))+match[2];if(p<1)requestAnimationFrame(count);else e.target.textContent=final;};
      requestAnimationFrame(count);
    }),{threshold:.7});document.querySelectorAll('#caqa-in-numbers .cr-stat-card>strong').forEach(e=>stats.observe(e));
  }
})();
